module.exports = __webpack_public_path__ + "img/play.3ec62dad.svg";